import { Injectable } from '@angular/core';
import { NavData } from "../models/NavData";
import {navItems} from "../containers/menu-items/_nav";
import {navItemsEN} from "../containers/menu-items/_nav_en";
import {navItemsFR} from "../containers/menu-items/_nav_fr";
import {navItemsPT} from "../containers/menu-items/_nav_pt";
import {navItemsCA} from "../containers/menu-items/_nav_ca";


@Injectable({
  providedIn: 'root'
})


export class MenuService {

  menu ={
    "es": navItems,      
    "en": navItemsEN,
    "fr": navItemsFR,
    "pt": navItemsPT,
    "ca": navItemsCA
  }

  constructor() {	
  }

  getMenu(locale: string): NavData[] {        
    return this.menu[locale];
  }

  
}
